/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ActivityDto } from '../models/activity-dto';
import { CertificateDto } from '../models/certificate-dto';
import { CompetenceDto } from '../models/competence-dto';
import { SkillDto } from '../models/skill-dto';

@Injectable({
  providedIn: 'root',
})
export class SkillRestControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createOrUpdateSkill
   */
  static readonly CreateOrUpdateSkillPath = '/api/v1/skillController';

  /**
   * Adds updates Skill for cv.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createOrUpdateSkill()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateSkill$Response(params: {
    cvId: number;
    body: SkillDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SkillDto>> {

    const rb = new RequestBuilder(this.rootUrl, SkillRestControllerService.CreateOrUpdateSkillPath, 'post');
    if (params) {
      rb.query('cvId', params.cvId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SkillDto>;
      })
    );
  }

  /**
   * Adds updates Skill for cv.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createOrUpdateSkill$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createOrUpdateSkill(params: {
    cvId: number;
    body: SkillDto
  },
  context?: HttpContext

): Observable<SkillDto> {

    return this.createOrUpdateSkill$Response(params,context).pipe(
      map((r: StrictHttpResponse<SkillDto>) => r.body as SkillDto)
    );
  }

  /**
   * Path part for operation getSkillById
   */
  static readonly GetSkillByIdPath = '/api/v1/skillController/{id}';

  /**
   * Provides SkillDto based on given Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSkillById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSkillById$Response(params: {
    id: number;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<SkillDto>> {

    const rb = new RequestBuilder(this.rootUrl, SkillRestControllerService.GetSkillByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SkillDto>;
      })
    );
  }

  /**
   * Provides SkillDto based on given Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSkillById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSkillById(params: {
    id: number;
  },
  context?: HttpContext

): Observable<SkillDto> {

    return this.getSkillById$Response(params,context).pipe(
      map((r: StrictHttpResponse<SkillDto>) => r.body as SkillDto)
    );
  }

  /**
   * Path part for operation getSkills
   */
  static readonly GetSkillsPath = '/api/v1/skillController/all';

  /**
   * Provides the list of all Skills.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSkills()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSkills$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<SkillDto>>> {

    const rb = new RequestBuilder(this.rootUrl, SkillRestControllerService.GetSkillsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<SkillDto>>;
      })
    );
  }

  /**
   * Provides the list of all Skills.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSkills$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSkills(params?: {
  },
  context?: HttpContext

): Observable<Array<SkillDto>> {

    return this.getSkills$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<SkillDto>>) => r.body as Array<SkillDto>)
    );
  }

  /**
   * Path part for operation deleteProfessionalCompetence
   */
  static readonly DeleteProfessionalCompetencePath = '/api/v1/skillController/{skillId}/deleteProfessionalCompetence';

  /**
   * Removes Competence (ProfessionalCompetence) passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteProfessionalCompetence()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProfessionalCompetence$Response(params: {
    skillId: number;
    body: CompetenceDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SkillRestControllerService.DeleteProfessionalCompetencePath, 'delete');
    if (params) {
      rb.path('skillId', params.skillId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Competence (ProfessionalCompetence) passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteProfessionalCompetence$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteProfessionalCompetence(params: {
    skillId: number;
    body: CompetenceDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteProfessionalCompetence$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteItCompetence
   */
  static readonly DeleteItCompetencePath = '/api/v1/skillController/{skillId}/deleteItCompetence';

  /**
   * Removes Competence (ItCompetence) passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteItCompetence()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteItCompetence$Response(params: {
    skillId: number;
    body: CompetenceDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SkillRestControllerService.DeleteItCompetencePath, 'delete');
    if (params) {
      rb.path('skillId', params.skillId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Competence (ItCompetence) passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteItCompetence$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteItCompetence(params: {
    skillId: number;
    body: CompetenceDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteItCompetence$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteCertificate
   */
  static readonly DeleteCertificatePath = '/api/v1/skillController/{skillId}/deleteCertificate';

  /**
   * Removes Certificate passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCertificate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteCertificate$Response(params: {
    skillId: number;
    body: CertificateDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SkillRestControllerService.DeleteCertificatePath, 'delete');
    if (params) {
      rb.path('skillId', params.skillId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Certificate passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCertificate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteCertificate(params: {
    skillId: number;
    body: CertificateDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteCertificate$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation deleteActivity
   */
  static readonly DeleteActivityPath = '/api/v1/skillController/{skillId}/deleteActivity';

  /**
   * Removes Activity passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteActivity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteActivity$Response(params: {
    skillId: number;
    body: ActivityDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, SkillRestControllerService.DeleteActivityPath, 'delete');
    if (params) {
      rb.path('skillId', params.skillId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Removes Activity passed to the method from Skill based on the given skill Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteActivity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  deleteActivity(params: {
    skillId: number;
    body: ActivityDto
  },
  context?: HttpContext

): Observable<void> {

    return this.deleteActivity$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
